import { PostAdd } from '@mui/icons-material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Box, CircularProgress, MenuItem, Popover } from '@mui/material';
import { useTranslation } from 'react-i18next';

const DraftPostActionPopup = ({ popoverElement, handleCloseMenu, handleUploadDraft, handleDeleteDraft, loading }) => {
  const { t: translate } = useTranslation();
  return (
    <Popover
      open={Boolean(popoverElement)}
      anchorEl={popoverElement}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: { p: 1, width: 140, '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 } },
      }}
    >
      {' '}
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <CircularProgress size={24} />
        </Box>
      ) : (
        <>
          <MenuItem sx={{ color: 'info.main' }} onClick={handleUploadDraft}>
            <PostAdd sx={{ mr: 1 }} /> {translate('draft.upload_draft')}
          </MenuItem>
          <MenuItem sx={{ color: 'error.main' }} onClick={handleDeleteDraft}>
            <DeleteForeverIcon sx={{ mr: 1 }} /> {translate('draft.delete_draft')}
          </MenuItem>
        </>
      )}
    </Popover>
  );
};
export default DraftPostActionPopup;
